<div class="input-group input-group-sm">
  <input type="search"
         name="search"
         class="form-control"
         placeholder="{{ 'header.search' | translate }}..."
         [formControl]="searchField"
         (keypress)="keypress($event)" />
  <span class="input-group-append">
    <button class="btn btn-outline-secondary" type="button" (click)="doSearch()"><i class="fa fa-search"></i></button>
  </span>
</div>

